var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"m37.7 12.9 1.5-1.3-8-8.9-1.6 1.3 2 2.2-1.6 1.5c-2.2-1.7-4.8-3-7.7-3.5v-2h3v-2h-12v2h3v1.8c-8.7 1.2-15.5 8.7-15.5 17.8 0 9.9 8.1 18 18 18s18-8.1 18-18c0-3.6-1-6.9-2.8-9.7l1.7-1.5zm-18.9 25.6c-9.24923077 0-16.7-7.4507692-16.7-16.7s7.45076923-16.7 16.7-16.7c9.2492308 0 16.7 7.4507692 16.7 16.7s-7.4507692 16.7-16.7 16.7z","key":0}),React.createElement("path",{"d":"m18.4545455 8-.4545455 16.2h2.5l-.530303-16.2z","key":1}),React.createElement("path",{"d":"m22.0281259 15.2353553-.4545455 11.2568543h2.5l-.530303-11.2568543z","transform":"matrix(.70710678 .70710678 -.70710678 .70710678 21.437794 -10.027848)","key":2})]));
}

Clock.defaultProps = {"height":"40","viewBox":"0 0 40 40","width":"40"};

module.exports = Clock;

Clock.default = Clock;
